import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';
import App from './App';
import baseTheme from './theme';
import { AuthProvider } from './context/AuthContext';
import { AppProvider, useApp } from './context/AppContext';

// Componente wrapper que provee el tema dinámico
const ThemedApp = () => {
  const { darkMode } = useApp();
  
  // Crear tema basado en el modo oscuro
  const theme = createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      mode: darkMode ? 'dark' : 'light',
      background: darkMode 
        ? { default: '#121212', paper: '#1e1e1e' }
        : { default: '#f5f5f5', paper: '#ffffff' },
      text: darkMode 
        ? { primary: '#ffffff', secondary: '#b0b0b0' }
        : { primary: '#212121', secondary: '#757575' },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AppProvider>
          <ThemedApp />
        </AppProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
